import { useContext, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { Box } from '@mui/material'
import Toolbar from '../Toolbar'
import EditRequestModal from '../EditRequestModal'
import SFAFDrawer from '../SFAFDrawer'
import TableComponent from '../../../shared/Table'
import { AuthContext } from '../../../../contexts/auth.context'
import { RequestContext } from '../../../../contexts/request.context'
import { ISpecManRequestFrequency } from '../../../../../shared/types/api/spectrum-manager.type'
import { getSingleRequest } from '../../../../services/request-form.service'
import { RequestTableConfigs } from '../../../../utils/constants'
import { SpectrumManagerContext } from '../../../../contexts/spectrum.context'
import { createFrequencyForGroup, updateFrequencyRequest } from '../../../../services/spectrum-manager.service'
import { AppConfigContext } from '../../../../contexts/app-config.context'

import styles from './styles.module.scss'

const Requests = () => {
  const [completingItem, setCompletingItem] = useState<ISpecManRequestFrequency | null>(null)
  const [isViewMode, setIsViewMode] = useState(false)
  const [selectedRequestRow, setSelectedRequestRow] = useState<ISpecManRequestFrequency | null>(null)

  const { filterOptions, detailedRequests, setDetailedRequests, getDetailedRequests } =
    useContext(SpectrumManagerContext)

  const { user } = useContext(AuthContext)
  const { isLightMode } = useContext(AppConfigContext)
  const { setSelectedRequest } = useContext(RequestContext)

  const getRequest = async () => {
    if (completingItem) {
      const data = await getSingleRequest(completingItem.request_id)

      if (data.data) {
        const parsedRequest = {
          ...data.data,
          start_date: dayjs(data.data.start_date),
          end_date: dayjs(data.data.end_date),
        }
        setSelectedRequest(parsedRequest)
      }
    }
  }

  const handleView = (request: ISpecManRequestFrequency) => {
    setIsViewMode(true)
    setSelectedRequestRow(request)
  }

  const handleClose = () => {
    setIsViewMode(false)
    setSelectedRequest(null)
  }

  const handleSave = async (request: ISpecManRequestFrequency) => {
    const data = await updateFrequencyRequest(
      request.frequency_group_id,
      request.radius_306,
      request.radius_406,
      request.number_of_frequencies,
    )

    const updatedRequest = detailedRequests.find((elem) => elem.frequency_group_id === request.frequency_group_id)

    setDetailedRequests((prev) =>
      prev.map((elem) => (elem.frequency_group_id === request.frequency_group_id ? request : elem)),
    )

    if (data.success && updatedRequest) {
      const freqDiff = (request.number_of_frequencies ?? 0) - (updatedRequest.number_of_frequencies ?? 0)

      for (let i = 0; i < freqDiff; i++) {
        await createFrequencyForGroup(request.frequency_group_id)
      }
    }
  }

  useEffect(() => {
    getRequest()
  }, [completingItem])

  useEffect(() => {
    if (user) getDetailedRequests(user.id)
  }, [user, filterOptions])

  return (
    <Box className={styles.requests}>
      <TableComponent
        data={detailedRequests}
        handleSave={handleSave}
        configs={RequestTableConfigs}
        handleView={handleView}
        isLightMode={isLightMode}
        isIncomplete={true}
        handleSelect={(row: any) => {
          setSelectedRequest({
            ...row,
            id: row.request_id,
            start_date: dayjs(row.start_date),
            end_date: dayjs(row.end_date),
          })
        }}
        setIsCompleting={setCompletingItem}
        preface={<Toolbar selectedRequest={selectedRequestRow} />}
      />
      {completingItem && (
        <EditRequestModal
          isOpen={!!completingItem}
          onClose={() => setCompletingItem(null)}
          isLightMode={isLightMode}
          detailedRequest={completingItem}
        />
      )}
      {selectedRequestRow && <SFAFDrawer isOpen={isViewMode} request={selectedRequestRow} handleClose={handleClose} />}
    </Box>
  )
}

export default Requests
